import { useContext } from 'react';
import styled from 'styled-components';

import { ConversationContext } from '../../../../../../context/conversationContext';

import { ReactComponent as CloseIconSvg } from '../../../../../../assets/close_icon.svg';
import { fadeIn } from '../../../../../../styles/animation';

const Panel: React.FC<React.PropsWithChildren> = ({ children }) => {
  const conversationContext = useContext(ConversationContext);

  return (
    <PanelWrapper>
      <Header>
        <CloseButton
          type="button"
          onClick={() => conversationContext?.setPanelContent(undefined)}
        >
          <CloseIconSvg />
        </CloseButton>
      </Header>
      {children}
    </PanelWrapper>
  );
};

export default Panel;

const Header = styled.div`
  position: absolute;
  top: 12px;
  right: 0;
  height: 30px;
`;

const CloseButton = styled.button`
  border: none;
  background-color: transparent;
`;

const PanelWrapper = styled.div`
  max-width: 58vw;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  height: calc(100vh - 76px);
  overflow-y: auto;
  position: relative;
  animation: ${fadeIn} 0.4s ease-in-out forwards;
`;
